<template>
  <div>
    <div class="com-card">
      <div class="com-card-content">
        <ul class="com-list-grid">
          <li v-for="lst in list" :key="lst.url" @click="toNext(lst)">
            <img :src="lst.cover" />
            <div class="text">
              <p class="t1">{{ lst.name }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import { getUserInfo } from '@/utils/auth'
  export default {
    data () {
      return {
        userInfo: getUserInfo(),
        list: [
          {
            name: '年度法会',
            cover: '/static/images/niandufahui.jpg',
            url: './fahui'
          },
          {
            name: '日常佛事',
            cover: '/static/images/richangfoshi.jpg',
            url: './foshi'
          },
          {
            name: '广种福田',
            cover: '/static/images/guangzhongfutian.jpg',
            url: './futian'
          },
          {
            name: '愿生安养',
            cover: '/static/images/yuanshenganyang.jpg',
            url: './anyang'
          }
        ]
      }
    },
    methods: {
      // 详情页
      toNext (item) {
        this.$router.push({
          path: item.url
        })
      }
    }
  }
</script>